<template>
  <App>
    <router-view />
  </App>
</template>

<script>
import { App } from '@wizer/core/components/app'

const axios = require('axios')

if (process.env.NODE_ENV === 'development') {
  const credentials = btoa(
    `${process.env.VUE_APP_E360_USERNAME}:${process.env.VUE_APP_E360_PASSWORD}`,
  )
  axios.defaults.headers.common.Authorization = `Basic ${credentials}`
  axios.defaults.withCredentials = true
}

axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
axios.defaults.xsrfCookieName = 'csrftoken'

function loadCssFile(filename) {
  const fileRef = document.createElement('link')
  fileRef.setAttribute('rel', 'stylesheet')
  fileRef.setAttribute('type', 'text/css')
  fileRef.setAttribute('href', filename)
  document.getElementsByTagName('head')[0].appendChild(fileRef)
}

loadCssFile(`${process.env.VUE_APP_E360_BASE_URL}custom/css/custom.css`)

export default {
  components: {
    App,
  },
}
</script>

<style>
/** For now we're assuming that this vue app is displayed in an iframe
and we don't want vertical scrollbar */
html {
  overflow-y: hidden;
}
</style>
